import type { IEnvConfig } from "@adgm/cross-models";

const apikeyBugsnagDev = "ce04cf79558d4491ae9fe634baf50882";
const OSSURL = "https://aspen-dev.oss-ap-southeast-1.aliyuncs.com";
const staticHost = `https://static.dev.test-aspendigital.co`;
const dev: IEnvConfig = {
  env: "dev",
  host: "https://api-ad-dev.test-aspendigital.co/",
  websocket: {
    host: "wss://ws-ad-dev.test-aspendigital.co:8080", // aspen dev
  },
  googlePlayUrl: "https://www.pgyer.com/T8727P5S",
  appStoreUrl: "https://www.pgyer.com/drqX",
  ossUrl: OSSURL, //策略图片oss地址
  appDomain: "https://apponly-ad-dev.test-aspendigital.co/",
  webDomain: "https://portal-ad-dev.test-aspendigital.co",
  domainUriPrefix: "https://dev-adgm.onelink.me/9CqI",
  staticHost,
  // 蒲公英
  fallbackUrl: {
    android: "https://www.pgyer.com/T8727P5S",
    ios: "https://www.pgyer.com/drqX",
  },
  packageName: {
    android: "com.aspendigital.adgm.dev",
    ios: "com.aspendigital.adgm.dev",
  },

  klineChartUrl: "",
  tvChartUrl: "https://tradingview-ad-dev.test-aspendigital.co/",
  apiKeyBugsnag: apikeyBugsnagDev,
  minimumVersion: {
    android: "",
    ios: "",
  },
  operationServer: "https://api-aoperation-ad-dev.test-aspendigital.co/",
  saasServer: "",
  appScheme: "DevADGM",
  universalDownloadLink: "https://beta-adgm.onelink.me/9CqI/vw141dv5",
  aiChatUrl:
    "https://adgm-ai-git-review-edgen-ai-beta-aspendigitallimited.vercel.app/en/adgm-edgen",
};
export default dev;
